export class FilterSignatures {
    f!: string;
    n!: string;
    ps!: string;
    ms!: string;
    d!: number;
    a!: number;
    ac!: number;
    status!: string;

}